import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Layout from 'components/sales/layout/layout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';

const isValidMobile = (value) => /^[6-9]\d{9}$/.test(String(value || '').trim());

const DeviceDelink = ({ fetchUserDevices, deactivateUserDevice }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [fieldError, setFieldError] = useState('');

  const handleSubmit = async () => {
    const mobile = String(phoneNumber || '').trim();

    if (!isValidMobile(mobile)) {
      const message = 'Enter a valid 10-digit mobile number';
      setFieldError(message);
      toast.error(message);
      return;
    }

    setFieldError('');
    setIsLoading(true);

    try {
      const devices = await fetchUserDevices(mobile);
      const activeDevices = devices.filter((device) => device.active === true);

      if (!activeDevices.length) {
        toast.error('No active device found for this mobile number');
        return;
      }

      for (const device of activeDevices) {
        if (!device?.id) {
          throw new Error('Device id missing in response');
        }
        await deactivateUserDevice(device.id);
      }

      setPhoneNumber('');
      toast.success(localization.submittedSuccessfully);
    } catch (err) {
      toast.error(err.message || localization.failed);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout title={localization.deviceDelink} Buttons={() => <></>} isLoading={isLoading}>
      <div className="container mt-3">
        <div className="card">
          <div className="card-body">
            <div className="row align-items-end">
              <div className="col-md-6">
                <ConstantInput
                  label="Mobile Number"
                  type="text"
                  value={phoneNumber}
                  handleChange={(val) => {
                    setPhoneNumber(String(val || '').replace(/\D/g, '').slice(0, 10));
                    setFieldError('');
                  }}
                  required
                  maxLength={10}
                  isStarRequired={true}
                  checkDigits
                  tenDigitsValidation
                  errorMsg={fieldError || 'Enter a valid 10-digit mobile number'}
                  blockError={Boolean(fieldError)}
                />
              </div>
              <div className="col-md-3 mb-3">
                <Button
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  Delink Device
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DeviceDelink;
